import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { noop } from '../../common/helpers';

import TreeViewNode from './TreeViewNode';

var TreeView = function TreeView(_ref) {
  var nodes = _ref.nodes,
      selectNode = _ref.selectNode,
      highlightOnSelect = _ref.highlightOnSelect,
      highlightOnHover = _ref.highlightOnHover;

  var classes = classNames('list-group', {
    'treeview-pf-select': highlightOnSelect,
    'treeview-pf-hover': highlightOnHover
  });

  return React.createElement(
    'div',
    { className: 'treeview' },
    React.createElement(
      'ul',
      { className: classes },
      nodes && nodes.map(function (node, index) {
        return React.createElement(TreeViewNode, {
          node: node,
          key: index,
          level: 1,
          selectNode: selectNode
        });
      })
    )
  );
};

TreeView.propTypes = {
  /** Array of node objects */
  nodes: PropTypes.array,
  /** Function that will be triggered when a selectable node is clicked */
  selectNode: PropTypes.func,
  /** Highlight node row on hover */
  highlightOnHover: PropTypes.bool,
  /** Highlight node row when clicked */
  highlightOnSelect: PropTypes.bool
};

TreeView.defaultProps = {
  highlightOnHover: false,
  highlightOnSelect: false,
  nodes: [],
  selectNode: noop
};

export default TreeView;


//////////////////
// WEBPACK FOOTER
// ./node_modules/patternfly-react/dist/esm/components/TreeView/TreeView.js
// module id = 859
// module chunks = 0